import React, { useState, useCallback, useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import Toolbar, { Item } from "devextreme-react/toolbar";
import { Button } from "devextreme-react/button";
import TextArea from 'devextreme-react/text-area';
import Popup from "devextreme-react/popup";
import axios from "axios";
import routes from "../../../assets/apiRoutes.json";
import Accordion from 'devextreme-react/accordion';
import { alert } from "devextreme/ui/dialog";
import GenerateItemReorderRecordsPreview from "../common/GenerateItemReorderRecordsPreview";
import CommonReport from "../../../reports/components/CommonReport";
import { LoadPanel } from "devextreme-react";
import { connect } from "react-redux";
import FormField from "../../../dynamicFormBuilder/FormField";
import { SearchLayout } from "./Layout";
import { TabPanel, Item as TabItem } from 'devextreme-react/tab-panel';
import { DisableEnableControls, loadLookupFromStaticDataSource, ShowHideControls } from "../../../common/Utils";
import { IM } from "../../../const/constants";
import GenerateItemReorderRecordsGrid from "../common/GenerateItemReorderRecordsGrid";
import { MESSAGES } from "../../../common/Messages";
import { SourceTypes } from "../../../enum/Enum";


const searchpanel = [
  {
    ID: 1,
    Name: 'Search Filters'
  }
];
const GenerateItemReorderRecords = (props) => {
  const initialFormFields = {
  Module: IM,
  PoProfile: null,
  RequisitionProfile: null,
  Source: props.source || SourceTypes.DropShip,
  Method: props.source===SourceTypes.Requisition ? "R" : null,
  TargetType: props.source===SourceTypes.Requisition ? "R" : "P",
  Description: '',
  TransDate: null,
  RequiredDate: null,
  ExpectedDate: null,
  InclVendor: '',
  ExpirationDate: null,
  LotStatus: 'A',
  Reference: '',
  InventBasis: 'A',
  Comment: '',
  filterWhereInfoListOM: [],
  filterWhereInfoListItem: [],
  filterWhereInfoListVendorCR: []
};
 const reportRefOM = useRef(null);
 const reportRefItem = useRef(null);
 const reportRefVendorCR = useRef(null);
  var accessToken = props.oidc.user.access_token;
  var currentUser = props.oidc.user;
  const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
  const formRefs = useRef({});
  const [previewData, setPreviewData] = useState(null);
  const [report, setReport] = useState({
    filterWhereInfoList: []
  });
  const [isPreviewGridPopupVisible, setIsPreviewGridPopupVisible] = useState(false);
  const [loadIndicatorVisible, setLoadIndicatorVisible] = useState(false);
  const [animationDuration] = useState(300);
  const [selectedItems, setSelectedItems] = useState(searchpanel);
  const [formFields, setformFields] = useState(initialFormFields);
  const [useGridComponent, setUseGridComponent] = useState(false); // Flag to toggle between FormField and Grid
  // Initialize showHeaderTab based on initial Method value (hide if 'A' or 'D')
  const [showHeaderTab, setShowHeaderTab] = useState(initialFormFields.Method !== 'R' && initialFormFields.Method !== 'V');

  const location = useLocation();

  // When navigated from Sales Order Profile "Create PO Requisition", load passed data into grid
  useEffect(() => {
    const state = location.state;
    if (state?.initialRequisitionData && Array.isArray(state.initialRequisitionData)) {
      setPreviewData(state.initialRequisitionData);
      setUseGridComponent(true);
      if (state.requisitionProfileId || state.profileRowId) {
        setformFields((prev) => ({
          ...prev,
          RequisitionProfile: state.requisitionProfileId || state.profileRowId,
          TargetType: 'R',
        }));
      }
    }
  }, []);

  const handleOMReportStateChange = useCallback((reportState) => {
    setformFields((prevFormFields) => ({
      ...prevFormFields,
      filterWhereInfoListOM: reportState?.filterWhereInfoList
    }));
  }, []);
  const handleItemReportStateChange = useCallback((reportState) => {
    setformFields((prevFormFields) => ({
      ...prevFormFields,
      filterWhereInfoListItem: reportState?.filterWhereInfoList
    }));
  }, []);
  const handleVendorCRReportStateChange = useCallback((reportState) => {
    setformFields((prevFormFields) => ({
      ...prevFormFields,
      filterWhereInfoListVendorCR: reportState?.filterWhereInfoList
    }));
  }, []);
  const handleClosePreviewPopUpCallback = useCallback(() => {
    setIsPreviewGridPopupVisible(false);
  }, []);

  const selectionChanged = useCallback((e) => {
    // Prevent accordion from opening if grid is shown
    if (useGridComponent) {
      return;
    }
    let newItems = [...selectedItems];
    e.removedItems.forEach((item) => {
      const index = newItems.indexOf(item);
      if (index >= 0) {
        newItems.splice(index, 1);
      }
    });
    if (e.addedItems.length) {
      newItems = [...newItems, ...e.addedItems];
    }
    setSelectedItems(newItems);
  }, [selectedItems, useGridComponent]);


  const PreviewData = useCallback(async () => {
    try {
      const requestData = {
        Module: formFields.Module || '',
        Source:props.source===SourceTypes.Requisition ? formFields.Method : SourceTypes.DropShip,
        FilterWhereInfoListOM: formFields.filterWhereInfoListOM || [],
        FilterWhereInfoListItem: formFields.filterWhereInfoListItem || [],
        FilterWhereInfoListVendorCR: formFields.filterWhereInfoListVendorCR || [],
        InventoryLevel: formFields.InventBasis || formFields.InventoryLevel || '',
        TargetType: formFields.TargetType || '',
        LotStatus: formFields.LotStatus || '',
        VcrDate: formFields.TransDate || ''
      };

      const res = await axios.post(
        `${window._env_.REACT_APP_APIS}/${routes.IM.Lot.GetReorderDataSet}`,
        JSON.stringify(requestData),
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      return res.data; // Return the response data
    } catch (error) {
      setLoadIndicatorVisible(false);
      console.error('Error:', error);
      throw error; // Re-throw the error for handling in the component
    }
  }, [formFields, accessToken]);

  const generateButtonClicked = async (e) => {
    if (e?.event)
      e.event.stopPropagation();
    if(!formFields.PoProfile && formFields.TargetType === "P"){
      alert(MESSAGES.PO_PROFILE_REQUIRED, MESSAGES.ERROR);
      return;
    }
    if(!formFields.RequisitionProfile && formFields.TargetType === "R"){
      alert(MESSAGES.REQUISITION_PROFILE_REQUIRED, MESSAGES.ERROR);
      return;
    }
      setLoadIndicatorVisible(true);

    try {
      const data = await PreviewData();
      setPreviewData(data);
      setUseGridComponent(true);
    } catch (error) {
      console.error('Error:', error);
      alert("Error: " + error.message, "Error");
    }
    finally {
      setLoadIndicatorVisible(false);
    }
  }

  const previewButtonClicked = useCallback(async (e) => {
    if (e?.event)
      e.event.stopPropagation();
    setLoadIndicatorVisible(true);
    const data = await PreviewData();
    setPreviewData(data);
    setIsPreviewGridPopupVisible(true);
    setLoadIndicatorVisible(false);
  }, [PreviewData]);

  const resetButtonClicked = useCallback((e) => {
    if (e?.event)
      e.event.stopPropagation();
    if (reportRefOM.current) {
      reportRefOM.current.loadReport();
    }
    if (reportRefItem.current) {
      reportRefItem.current.loadReport();
    }
    setformFields(initialFormFields);
    setUseGridComponent(false);
    setShowHeaderTab(initialFormFields.Method !== 'R' && initialFormFields.Method !== 'V');
  }, []);

  const handleFieldChange = useCallback((name, value) => {
    if (name === "TargetType") {
      if (value === "R") {
       DisableEnableControls("PoProfile", true, formRefs);
       DisableEnableControls("RequisitionProfile", false, formRefs);
      } else if (value === "P") {
        DisableEnableControls("RequisitionProfile", true, formRefs);
        DisableEnableControls("PoProfile", false, formRefs);
      }
    }
    if (name === "Method") {
      // Hide OM Header tab if Method is 'A' or 'D', otherwise show it
      setShowHeaderTab(value !== 'R' && value !== 'V');
    }
    // console.log(name, value);
  }, []);
  const handleSelectedItemChange = (name, e) => {
    if (name === "PoProfile") {
      const currentDate = new Date();
      setformFields((prevFormFields) => ({
        ...prevFormFields,
        Description: e.description ?? '',
        TransDate: e.requisitionDate?? currentDate,
        RequiredDate: e.dateRequired?? currentDate,
        ExpectedDate: e.dateExpected?? currentDate,
        ExpirationDate: e.expirationDate ?? currentDate,
        Comment: e.comment ?? '',
      }));
    }
    if (name === "RequisitionProfile") {
      const currentDate = new Date();
      setformFields((prevFormFields) => ({
        ...prevFormFields,
        Description: e.description ?? '',
        TransDate: e.requisitionDate?? currentDate,
        RequiredDate: e.dateRequired?? currentDate,
        ExpectedDate: e.dateExpected?? currentDate,
        ExpirationDate: e.expirationDate ?? currentDate,
        Comment: e.comment ?? '',
      }));
    }
  }
  const handleFormLoad = useCallback(() => {
    if(props.source !== SourceTypes.Requisition){
      ShowHideControls("RequisitionProfile", false, formRefs);
      ShowHideControls("TargetType", false, formRefs);
      ShowHideControls("Method", false, formRefs);
    }
    else{
      DisableEnableControls("RequisitionProfile", false, formRefs);
      DisableEnableControls("PoProfile", true, formRefs);
    }

    loadLookupFromStaticDataSource(
      "Module",
      [
        { key: 'IM', value: 'IM - Inventory Management' },
        { key: 'SI', value: 'SI - Supplies Inventory' },
        { key: 'PI', value: 'PI - Parts Inventory' }
      ],
      formFields,
      formRefs
    );
    loadLookupFromStaticDataSource(
      "InventBasis",
      [
        { key: 'A', value: 'Available' },
        { key: 'N', value: 'Net Available' },
        { key: 'H', value: 'On Hand' }
      ],
      formFields,
      formRefs
    );
    loadLookupFromStaticDataSource(
      "LotStatus",
      [
        { key: 'B', value: 'Both' },
        { key: 'A', value: 'Active' },
        { key: 'I', value: 'Inactive' }
      ],
      formFields,
      formRefs
    );
    loadLookupFromStaticDataSource(
      "TargetType",
      [
        { key: 'R', value: 'Requisition' },
        { key: 'P', value: 'Purchase Order' }
      ],
      formFields,
      formRefs
    );
    loadLookupFromStaticDataSource(
      "Method",
      [
        { key: 'R', value: 'Based on Reorder Levels' },
        { key: 'O', value: 'Based on Orders (OM) + Safety Quantity' },
        { key: 'M', value: 'Based on Orders (OM) Only' },
        { key: 'V', value: 'Based on Vendor Cross' },
      ],
      formFields,
      formRefs
    );
    
  }, []);

  // Collapse accordion when grid is shown
  useEffect(() => {
    if (useGridComponent) {
      setSelectedItems([]);
    }
  }, [useGridComponent]);
  return (
    <>
      <LoadPanel
        shadingColor="rgba(0,0,0,0.4)"
        onHiding={() => setLoadIndicatorVisible(false)}
        visible={loadIndicatorVisible}
        showIndicator={true}
        shading={true}
        showPane={true}
        hideOnOutsideClick={false}
      />
      <div className="row">
        <div className="col-md-12 main-page">
          <div id="accordion" >
            <Accordion
              dataSource={searchpanel}
              collapsible={true}
              multiple={false}
              animationDuration={animationDuration}
              selectedItems={selectedItems}
              onSelectionChanged={selectionChanged}
              
              itemTitleRender={() => (

                <Toolbar className="accordian-toolbar">
                  <Item location="before">
                    <div className="title">
                      <h6
                        style={{
                          color: window._env_.Color2
                        }}
                      >
                      {props.source===SourceTypes.Requisition ? "Generate Reorder Records" : "Generate PO Drop Ship Orders"}
                      </h6>
                    </div>
                  </Item>

                  <Item location="after">
                    <Button className="accordianButton" text="Generate Data" onClick={generateButtonClicked} type="default" />
                  </Item>
                  <Item location="after">
                    <Button className="accordianButton" onClick={previewButtonClicked} text="Preview" />
                  </Item>
                  <Item location="after">
                    <Button className="accordianButton" onClick={resetButtonClicked} text="Reset" />
                  </Item>
                </Toolbar>
              )}
              itemRender={(itemProps) => (
                <div>
                  <FormField
                    currrentUser={currentUser}
                    layoutId='4D34F946-AD81-4C6C-876E-93BE7E9F6C74'
                    layoutName='OMSalesOrderDataEntrySearchForm'
                    defaultFormSchema={SearchLayout}
                    formFields={formFields}
                    setformFields={setformFields}
                    handleFieldValueChange={handleFieldChange}
                    handleSelectedItemChange={handleSelectedItemChange}
                    DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                    formRefs={formRefs}
                    onFormLoad={handleFormLoad}
                  />

                </div>


              )}
              id="accordion-container" className="accordion-height"
            />
          </div>
        </div>
      </div>
      {useGridComponent ? (
        <GenerateItemReorderRecordsGrid
          dataSource={previewData || []}
          formFields={formFields}
          setLoadIndicatorVisible={setLoadIndicatorVisible}
        />
      ) : (
        <TabPanel>
          {showHeaderTab && (
            <TabItem title="OM Header">
              <CommonReport
                name="GENERATEPOHEADER"
                fullName="GENERATEPOHEADER"
                onReportStateChange={handleOMReportStateChange}
                innerRef={reportRefOM}
              />
            </TabItem>
          )}
          <TabItem title="Item/Lot">
            <CommonReport
              name="GENERATEPOITEM"
              fullName="GENERATEPOITEM"
              onReportStateChange={handleItemReportStateChange}
              innerRef={reportRefItem}
            />
          </TabItem>
          {props.source===SourceTypes.Requisition && (
          <TabItem title="Vendor Cross-Reference">
            <CommonReport
              name="GENERATEVENEDORCROSSREFERENCE"
              fullName="Argos.Report.IM.GenerateVenedorCrossReference, Argos.Report.IM"
              onReportStateChange={handleVendorCRReportStateChange}
              innerRef={reportRefVendorCR}
            />
          </TabItem>
          )}
        </TabPanel>
      )}

      {isPreviewGridPopupVisible &&
        <Popup
          visible={isPreviewGridPopupVisible}
          onHiding={handleClosePreviewPopUpCallback}
          dragEnabled={false}
          hideOnOutsideClick={true}
          showCloseButton={true}
          showTitle={true}
          title={"Preview"}
          container=".dx-viewport"
          closeOnOutsideClick={true}
        >
          <GenerateItemReorderRecordsPreview dataSource={previewData} />
        </Popup>
      }
    </>
  );
}

function mapStateToProps(state) {
  return {
    oidc: state.oidc,
    ReceiptReducer: state.ReceiptReducer,
  };
}
export default connect(mapStateToProps)(GenerateItemReorderRecords);